// Backend API URL Configuration
const ENVIRONMENTS = {
  development: 'http://localhost:5000',
  production: 'https://api.wwwsms.org'
};

// Set this to 'development' or 'production' to change the API endpoint
const CURRENT_ENV = 'production';

// Automatically use environment variables if available (for deployment environments)
// Otherwise fall back to the manually set environment
const API_URL = process.env.REACT_APP_API_URL || ENVIRONMENTS[CURRENT_ENV];

console.log(`Using API endpoint: ${API_URL} (${CURRENT_ENV} environment)`);

export { API_URL };
